// extracted by mini-css-extract-plugin
export default {"projectBody":"ProjectScStyle_projectBody__FXEJ7","title":"ProjectScStyle_title__uvRam"};